import { createSlice } from '@reduxjs/toolkit'

const INIT_STATE = {
  token: null,
}

const { actions, reducer } = createSlice({
  name: 'esainiDoc',
  initialState: INIT_STATE,
  reducers: {
    setToken: (state, { payload }) => {
      state.token = payload
    },
    clearToken: (state) => {
      state.token = null
    },
  },
})

export const { setToken, clearToken } = actions

export default reducer
